const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "16%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "9%"
  },
  {
    key: "avgTemperature",
    zh: "平均温度(℃)",
    en: "Average Temperature(℃)",
    width: "13%",
    tooltip: true
  },
  {
    key: "avgPressure",
    zh: "平均压力(MPa)",
    en: "Average Pressure(MPa)",
    width: "12%",
    tooltip: true
  },
  {
    key: "avgFrequency",
    zh: "平均频率(Hz)'",
    en: "Average Frequency(Hz)",
    width: "12%",
    tooltip: true
  },
  {
    key: "avgElectric",
    zh: "平均电流(A)",
    en: "Average Current(A)",
    width: "12%",
    tooltip: true
  },
  {
    key: "ratedElectric",
    zh: "额定电流(A)",
    en: "Rated Current(A)",
    width: "12%",
    tooltip: true
  }
]

export default columns